<template>
  <div class="row">
    <div class="col-lg-5">
      <div v-if="studentitems" class="student-profile-card card border-0 mb-4">
        <div class="card-body text-center">
          <img
            v-if="studentitems.passport"
            :src="studentitems.passport"
            class="rounded-circle profile-avatar"
            alt=""
          />
          <img
            v-else
            src="/img/brand/loguser.png"
            class="rounded-circle profile-avatar"
            alt=""
          />
          <h3 class="mb-1 mt-3 text-white">{{ studentitems.studentName }}</h3>
          <div class="profile-meta">
            <span class="badge badge-pill badge-light">{{
              studentitems.admNo
            }}</span>
            <span class="badge badge-pill badge-light">{{
              studentitems.sch_Class
            }}</span>
            <span class="badge badge-pill badge-light">{{
              studentitems.classOption
            }}</span>
            <span class="badge badge-pill badge-light">{{
              studentitems.sectionName
            }}</span>
          </div>
        </div>
      </div>

      <div class="card achievement-form-card border-0 mb-0">
        <div class="card-header bg-transparent">
          <h3 class="mb-0">
            <i class="fa fa-trophy mr-2"></i
            >{{ process === "U" ? "Edit Achievement" : "New Achievement" }}
          </h3>
        </div>
        <div class="card-body">
          <form role="form" @submit.prevent="SubmitAchievement">
            <div class="form-group">
              <label>Date</label>
              <input
                type="date"
                v-model="DateArchievedval"
                class="form-control"
                required
              />
            </div>
            <div class="form-group">
              <label>Heading</label>
              <vue-editor id="Headingval" v-model="Headingval"></vue-editor>
            </div>
            <div class="form-group">
              <label>Detail</label>
              <vue-editor id="Detailval" v-model="Detailval"></vue-editor>
            </div>
            <div class="col-md-12 pb-2">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <img v-if="ImgPathval" :src="ImgPathval" class="img-fluid" />
                  <img v-else src="/img/brand/empty.png" class="img-fluid" />
                </div>
                <div class="col-sm-12 col-md-6">
                  <ImageUploader @emitOutImgPathval="updateImgPathval" />
                </div>
              </div>
            </div>

            <div class="text-center mt-4">
              <button
                type="submit"
                class="btn btn-success px-5"
                :disabled="isSubmittingAchievement"
              >
                <i
                  :class="
                    isSubmittingAchievement
                      ? 'fa fa-spinner fa-spin mr-1'
                      : 'fa fa-check mr-1'
                  "
                ></i>
                {{ isSubmittingAchievement ? "Submitting..." : "Submit" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-lg-7">
      <h3 class="mb-4">
        <i class="fa fa-list-alt text-success mr-2"></i>Achievement History
      </h3>
      <div
        v-if="!studentarchievementitem || studentarchievementitem.length === 0"
        class="text-center text-muted py-5"
      >
        <i class="fa fa-inbox fa-2x mb-2"></i>
        <p>No achievements recorded yet</p>
      </div>
      <div class="achievement-timeline" v-else>
        <div
          v-for="item in studentarchievementitem"
          :key="item.Id"
          class="achievement-item"
        >
          <div class="achievement-dot"></div>
          <div class="card achievement-card border-0">
            <div class="card-body">
              <div
                class="d-flex justify-content-between align-items-start flex-wrap"
              >
                <span class="badge badge-pill badge-success">{{
                  formatDateOnly(item.DateCreated)
                }}</span>
                <button
                  class="btn btn-outline-secondary btn-sm"
                  v-on:click="edititem(item)"
                >
                  <i class="fa fa-edit"></i> Edit
                </button>
              </div>
              <img
                v-if="item.ImgPath"
                height="100"
                class="rounded mt-3 mb-2"
                :src="item.ImgPath"
                alt=""
              />
              <div class="mt-2 achievement-heading" v-html="item.Heading"></div>
              <div class="achievement-detail" v-html="item.Detail"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "quill/dist/quill.snow.css";
import { VueEditor } from "vue2-quill-editor";
import Alert from "@/mixins/Alert.mixins";
import DateFormaterMixin from "@/mixins/DateFormater.mixin";
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin";
import ImageUploader from "@/components/ImageUploader";
import katex from "katex";
import "katex/dist/katex.min.css";
window.katex = katex;
export default {
  name: "StudentAchievement",
  mixins: [CheckStaffUser, Alert, DateFormaterMixin],
  components: {
    VueEditor,
    ImageUploader,
  },
  props: {
    studentId: {
      type: [String, Number],
      default: null,
    },
    studentDetails: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      accessDetails: null,
      dataid: 0,
      Headingval: "",
      Detailval: "",
      DateArchievedval: "",
      ImgPathval: "",
      uploadedimage: "",
      studentarchievementitem: null,
      process: "N",
      onloader: "none",
      isSubmittingAchievement: false,
    };
  },
  computed: {
    // falls back to localStorage so the component still works when used standalone without props
    StudentIdVal() {
      if (this.studentId !== null && this.studentId !== undefined) {
        return this.studentId;
      }
      return localStorage.getItem("StudentId");
    },
    studentitems() {
      return this.studentDetails;
    },
  },
  watch: {
    StudentIdVal: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getstudentarchievement();
        }
      },
    },
  },
  methods: {
    updateImgPathval(data) {
      this.ImgPathval = data;
    },
    edititem(item) {
      if (!item) return;

      this.dataid = item.Id;
      this.process = "U";
      this.Headingval = item.Heading || "";
      this.Detailval = item.Detail || "";
      this.DateArchievedval = item.DateCreated
        ? this.frontEndDateFormat(item.DateCreated)
        : "";
      this.ImgPathval = item.ImgPath || "";
      this.uploadedimage = item.ImgPath || "";
    },
    async SubmitAchievement() {
      if (this.isSubmittingAchievement) return;
      if (!this.StudentIdVal) {
        this.ShowAlertError("No student selected", "");
        return;
      }
      if (!this.DateArchievedval) {
        this.ShowAlertError("Please select a date", "");
        return;
      }
      if (!this.Headingval || !this.Headingval.trim()) {
        this.ShowAlertError("Please enter a heading", "");
        return;
      }
      if (!this.Detailval || !this.Detailval.trim()) {
        this.ShowAlertError("Please enter a detail", "");
        return;
      }
      let Id = this.dataid;
      let StudId = this.StudentIdVal;
      let Heading = this.Headingval;
      let Detail = this.Detailval;
      let DateArchieved = this.DateArchievedval;
      let ImgPath = this.ImgPathval;
      let processop = this.process;
      let username = this.$store.state.auth.username;
      let accesskey = this.$store.state.auth.accesskey;
      let userdata = {
        Id,
        Heading,
        Detail,
        DateArchieved,
        ImgPath,
        StudId,
        processop,
        username,
        accesskey,
      };
      this.isSubmittingAchievement = true;
      this.onloader = "flex";
      try {
        const resp = await this.$store.dispatch(
          "studentachievementregistration",
          userdata
        );
        if (resp && resp.responseCode && resp.responseCode !== "00") {
          this.ShowAlertError(
            resp.responseMessage || "The achievement could not be saved.",
            ""
          );
          return;
        }

        const updatedItems = Array.isArray(resp)
          ? resp
          : resp && Array.isArray(resp.data)
          ? resp.data
          : null;
        if (updatedItems) {
          this.studentarchievementitem = this.sortByDateCreated(updatedItems);
        } else {
          await this.getstudentarchievement();
        }

        this.process = "N";
        this.dataid = 0;
        this.Headingval = "";
        this.ImgPathval = "";
        this.uploadedimage = "";
        this.DateArchievedval = "";
        this.Detailval = "";
        this.ShowAlertSuccess("Submitted Successfully", "");
      } catch (err) {
        const responseData = err && err.response && err.response.data;
        const message =
          (typeof responseData === "string" && responseData) ||
          (responseData &&
            (responseData.message || responseData.responseMessage)) ||
          (err && err.message) ||
          "The achievement could not be saved.";
        this.ShowAlertError(message, "");
      } finally {
        this.onloader = "none";
        this.isSubmittingAchievement = false;
      }
    },
    async getstudentarchievement() {
      let StudId = this.StudentIdVal;
      if (!(StudId > 0)) return [];
      this.onloader = "flex";
      try {
        const resp = await this.$store.dispatch(
          "getstudentarchievement",
          StudId
        );
        const items = Array.isArray(resp) ? resp : [];
        this.studentarchievementitem = this.sortByDateCreated(items);
        return this.studentarchievementitem;
      } catch (err) {
        const responseData = err && err.response && err.response.data;
        this.ShowAlertError(
          (typeof responseData === "string" && responseData) ||
            (responseData &&
              (responseData.message || responseData.responseMessage)) ||
            (err && err.message) ||
            "Could not load student achievements.",
          ""
        );
        return [];
      } finally {
        this.onloader = "none";
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.submitFile();
    },
    submitFile() {
      this.onloader = "flex";
      var form = new FormData();
      let username = this.$store.state.auth.username;
      let accesskey = this.$store.state.auth.accesskey;
      let formalurl = this.ImgPathval;
      let doctype = "image";
      form.append("username", username);
      form.append("accesskey", accesskey);
      form.append("formalurl", formalurl);
      form.append("doctype", doctype);
      form.append("file", this.file);
      this.$store
        .dispatch("uploadfile", form)
        .then((resp) => {
          this.ImgPathval = resp;
          this.uploadedimage = resp;
          this.onloader = "none";
          this.ShowAlertSuccess("Uploaded Successfully", "");
        })
        .catch((err) => {
          this.onloader = "none";
          this.ShowAlertError(err.response.data, "");
        });
    },
    frontEndDateFormat(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    backEndDateFormat(date) {
      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.accessDetails = this.$store.getters["auth/_user"];
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch("auth/Logout");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.student-profile-card {
  background: linear-gradient(87deg, #123e86 0, #0f06b8 100%);
}

.profile-avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 3px solid #fff;
  box-shadow: 0 0 0 3px #2d3dce;
}

.profile-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  justify-content: center;
  margin-top: 0.5rem;
}

.achievement-form-card {
  background: linear-gradient(87deg, #f2f2f5 0, #f3f3f5 100%);
}

.achievement-preview {
  max-height: 90px;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.achievement-timeline {
  position: relative;
  padding-left: 1.5rem;
}

.achievement-timeline::before {
  content: "";
  position: absolute;
  left: 0.4rem;
  top: 0.5rem;
  bottom: 0.5rem;
  width: 2px;
  background: #e9ecef;
}

.achievement-item {
  position: relative;
  margin-bottom: 1.5rem;
}

.achievement-dot {
  position: absolute;
  left: -1.5rem;
  top: 1.25rem;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #302dce;
  box-shadow: 0 0 0 3px #d7f7e8;
}

.achievement-card {
  box-shadow: 0 1px 8px rgba(50, 50, 93, 0.1);
  transition: box-shadow 0.2s ease;
}

.achievement-card:hover {
  box-shadow: 0 4px 16px rgba(50, 50, 93, 0.18);
}

.achievement-heading {
  font-weight: 600;
}

.achievement-detail {
  color: #525f7f;
}
</style>
